import type { PatchTargetsRequest } from "../../../generated-api";
import { client } from "../../../lib/api";

export async function patchTarget(data: unknown): Promise<boolean> {
  const raw = data as PatchTargetsRequest;

  return client.targets
    .patchTargets({
      requestBody: raw,
    })
    .then(() => true);
}
